"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlankNote = void 0;
const Note_1 = require("../Note");
const NoteType_1 = require("../lib/NoteType");
class BlankNote extends Note_1.Note {
    constructor() {
        super(NoteType_1.NoteType.Blank);
    }
}
exports.BlankNote = BlankNote;
